import { z } from 'zod'

export const schema = z.object({
  min: z.string(),
  max: z.string(),
})
export type FormType = z.infer<typeof schema>
